import _extends from "@babel/runtime/helpers/extends";
import { withZones } from '@beef/react/enhancers';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import style from "./styles.pcss";
var cn = classNames.bind(style);
var EChild = /*#__PURE__*/function (EChild) {
  EChild["Input"] = "Input";
  EChild["Buttons"] = "Buttons";
  EChild["Note"] = "Note";
  return EChild;
}(EChild || {});
export var FormLayout = withZones(Object.keys(EChild))( /*#__PURE__*/memo(function (props) {
  var _props$wrapperProps, _props$buttonWrapperP;
  var zones = props.zones;
  return /*#__PURE__*/React.createElement("div", _extends({}, props.wrapperProps, {
    className: cn('wrapper', (_props$wrapperProps = props.wrapperProps) === null || _props$wrapperProps === void 0 ? void 0 : _props$wrapperProps.className),
    "data-t-id": "components-FormLayout"
  }), zones[EChild.Input], zones[EChild.Buttons] && /*#__PURE__*/React.createElement("div", _extends({}, props.buttonWrapperProps, {
    className: cn('buttons', (_props$buttonWrapperP = props.buttonWrapperProps) === null || _props$buttonWrapperP === void 0 ? void 0 : _props$buttonWrapperP.className)
  }), zones[EChild.Buttons], zones[EChild.Note] && /*#__PURE__*/React.createElement(Text, {
    color: "tertiary",
    size: "2xs"
  }, zones[EChild.Note])));
}));